import React, { useState, useEffect } from 'react';
import { useMiddleman } from '@hubins/middleman';
import __ from 'localisation';
import LoadingBar from '@hubins/components/LoadingIndicators';
import { Columns, Column } from 'components/Columns';
import SimpleTable from 'modules/Tables/SimpleTable';
import TextArea from 'components/Textarea';
import AuthDownloadLink from '@hubins/components/AuthDownloadLink';
import ErrorBoundary from 'components/ErrorBoundary';
import './index.scss';
const keyValueTableHeaders = [
  {
    Header: __('details'),
    accessor: 'key',
  },
  {
    Header: '',
    accessor: 'value',
  }
];

const keyValuesTableLoadingObj = {
  key: <LoadingBar />,
  value: <LoadingBar />,
};

const keyValuesTableLoadingState = [
  keyValuesTableLoadingObj,
  keyValuesTableLoadingObj,
  keyValuesTableLoadingObj,
  keyValuesTableLoadingObj,
];

const documentsLoadingObj = {
  download: <LoadingBar />,
  fileName: <LoadingBar />,
};

const documentsTableLoadingState = [
  documentsLoadingObj,
  documentsLoadingObj,
  documentsLoadingObj,
  documentsLoadingObj,
];
const documentsTableHeaders = [
  {
    Header: __('documents'),
    accessor: 'download',
    width: 25,
    Cell: ({row}) => {
      if (typeof row?.original?.fileName === 'string') {
        return (
          <AuthDownloadLink
            url={`/v1/fa/documents/download${row.original.fullPath}`}
            filename={row.original.fileName}
            icon="Download Bottom by Streamlinehq"
            onlyIcon={true}
          />
        )
      } else {
        return (
          <p>{row.value}</p>
        )
      }
    },
  },
  {
    Header: '',
    accessor: 'fileName',
    Cell: (row) => {
      if (typeof row.value === 'string') {
        return (
          <div className='table-hover-tooltip' data-hover-tooltip={row.value}>
            <p className="table-elipsis-wrapper">{row.value}</p>
          </div>
        )
      } else {
        return (
          <p>{row.value}</p>
        )
      }
  }
  },

  // {
  //   Header: '',
  //   accessor: 'created',
  //   width: 60,
  //   Cell: ({value}) => value ? formatDate(value) : ''
  // }
];



const HoldingsTableExpandableContent = (props) => {
  const middleman = useMiddleman();

  const { row } = props;
  const { isExpanded } = row;
  const [keyValueTableData, setKeyValueTableData] = useState(keyValuesTableLoadingState);
  const [documents, setDocuments] = useState(documentsTableLoadingState);
  const [comments, setComments] = useState("");
  const [isFetched, setIsFetched] = useState(false);

  const isBond = row.type === 'BOND' || row.type === 'PROMNOTE' || row.type === 'INT';

  const init = async () => {
    try {
      const response = await middleman.get(`/holdings/security-extra-info/${row.id}`);
      const security = response.data;
      const formattedKeyValueTableData = [
        {
          key: __('due_date'),
          value: security?.maturityDate,
        },
        {
          key: __('security_issue_date'),
          value: security?.issueDate,
        },
        {
          key: __('coupon_frequency'),
          value: security?.couponFrequency ? __(`${security?.couponFrequency}`) : '',
        },
        {
          key: __('yearly-rate'),
          value: security?.profile?.yearlyInterestRate,
        },
      ];

      setKeyValueTableData(formattedKeyValueTableData);
      setDocuments(security?.documents || []);
      setComments(security?.profile?.comments || '');
      setIsFetched(true);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    if (isExpanded && !isFetched) {
      init();
    }
  }, [isExpanded, isFetched])

  return (
    <ErrorBoundary>
      <Columns>
      {isBond && (
          <Column m="4">
            <SimpleTable
              headers={keyValueTableHeaders}
              data={keyValueTableData}
            />
          </Column>
      )}
        <Column m={isBond ? "4" : "6"}>
          <div className="holdings-table-expandable-content__documents">
            <SimpleTable
              headers={documentsTableHeaders}
              data={documents}
            />
          </div>
        </Column>
        <Column m={isBond ? "4" : "6"}>
            <TextArea
              key={comments ? 'renderedComments' : 'emptyComments'}
              label={__('comments')}
              optionsState={{
                value: comments,
                error: false,
              }}
              disabled
            />
        </Column>
      </Columns>
    </ErrorBoundary>
  )
};

export default HoldingsTableExpandableContent;